<template>
  <div class="home" />
</template>

<script>
import {CONTACT_ROLE} from "@/shared/constants";

export default {
  name: "HomeView",
  created(){
    if(this.$store.state.auth.user.role === CONTACT_ROLE){
      this.$router.push('/appointment/user')
    }else{
      this.$router.push('/appointment')
    }
  }
};
</script>
